import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, withStyles } from '@material-ui/core';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FHEContainer } from 'data/components';
import FormTicket from './Form';
import { TicketHistory } from '../../components';

import {
    getFheTicketDetails,
    getFheTicketHistory,
    updateFheTicketState,
    deleteFheTicketHistory,
    addFheTicketHistoryMessage,
} from '../../data/TicketFhe/actions';

class TicketFheDetails extends Component {
    static propTypes = {
        getFheTicketDetails: PropTypes.func.isRequired,
        getFheTicketHistory: PropTypes.func.isRequired,
        updateFheTicketState: PropTypes.func.isRequired,
        deleteFheTicketHistory: PropTypes.func.isRequired,
        addFheTicketHistoryMessage: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        ticketId: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: null,
            ticketsHistory: {},
            nbRemainingLines: 0,
        };
    }

    componentDidMount() {
        this.getAllData();
    }

    getAllData = () => {
        const { initialized, getFheTicketDetails, getFheTicketHistory, ticketId } = this.props;

        this.setState({ loading: true, error: null });
        let promises = [getFheTicketHistory(ticketId, 0, 10)];
        if (!initialized) promises.push(getFheTicketDetails(ticketId));
        Promise.all(promises)
            .then(data => {
                this.setState({
                    ticketsHistory: data[0].ticketsHistory,
                    nbRemainingLines: data[0].remainingLines,
                    loading: false,
                    error: null,
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false,
                });
            });
    };

    getMoreFheTicketHistory = (offset = 0, limit = 10) => {
        const { ticketsHistory } = this.state;
        const { getFheTicketHistory, ticketId } = this.props;
        return getFheTicketHistory(ticketId, offset, limit)
            .then(data =>
                this.setState({
                    ticketsHistory: { ...ticketsHistory, ...data.ticketsHistory },
                    nbRemainingLines: data.remainingLines,
                }),
            )
            .catch(err => {
                throw err;
            });
    };
    updateFheTicketState = formData => {
        const { updateFheTicketState, ticketId } = this.props;
        return updateFheTicketState(ticketId, formData)
            .then(() => {
                Toastr.success(Translator.translate(`generic.ticketing.actions.editTicketSuccess`));
                this.getMoreFheTicketHistory();
            })
            .catch(error => {
                Toastr.error(Translator.translate('ticketsgit.issues.actions.updateError'));
                throw error;
            });
    };
    deleteFheTicketHistory = id => {
        const { ticketsHistory } = this.state;
        const { deleteFheTicketHistory, ticketId } = this.props;

        return deleteFheTicketHistory(id, parseInt(ticketId))
            .then(result => {
                Toastr.success(Translator.translate(`generic.ticketing.actions.deleteTicketHistorySuccess`));
                this.setState({
                    ticketsHistory: { ...ticketsHistory, ...result.ticketDeleted },
                });
            })
            .catch(err => {
                Toastr.error(Translator.translate(`generic.ticketing.actions.deleteTicketHistoryError`));
                throw err;
            });
    };

    addFheTicketHistoryMessage = message => {
        const { addFheTicketHistoryMessage, ticketId } = this.props;
        const { ticketsHistory } = this.state;

        return addFheTicketHistoryMessage(ticketId, message)
            .then(data => {
                Toastr.success(Translator.translate(`generic.ticketing.actions.messageTicketHistorySuccess`));
                this.setState({
                    ticketsHistory: { ...data.ticketHistoryAdded, ...ticketsHistory },
                });
            })
            .catch(() => {
                Toastr.error(Translator.translate(`generic.ticketing.actions.messageTicketHistoryError`));
            });
    };

    renderChildren = () => {
        const { ticketsHistory, nbRemainingLines } = this.state;
        const { ticketId, profile, history, classes } = this.props;

        const rightAddTicketHistory = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketHistoryAdd');
        const rightTicketHistoryList =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketHistoryList');

        return (
            <Grid container>
                <Grid container item sm={12} md={6} className={classes.panel}>
                    <div>
                        <FormTicket sendDataFunc={this.updateFheTicketState} />
                    </div>
                </Grid>
                <Grid container item sm={12} md={6} className={classes.panel}>
                    {rightTicketHistoryList && (
                        <TicketHistory
                            profile={profile}
                            nbRemainingLines={nbRemainingLines}
                            data={ticketsHistory}
                            ticketId={ticketId}
                            getMoreData={this.getMoreFheTicketHistory}
                            deleteMessage={this.deleteFheTicketHistory}
                            addMessage={rightAddTicketHistory && this.addFheTicketHistoryMessage}
                        />
                    )}
                </Grid>
            </Grid>
        );
    };

    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getAllData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    return {
        profile: state.data.user,
        ticketId: match.params.id,
        initialized: state.environments[history.environment].data.TicketFhe.get('initialized'),
    };
}

const styles = () => ({
    panel: {
        height: '70vh',
        width: '100%',
    },
});

export default withRouter(
    renderEnvComponent(
        'scenes/TicketFhe/details',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        getFheTicketDetails,
                        getFheTicketHistory,
                        updateFheTicketState,
                        deleteFheTicketHistory,
                        addFheTicketHistoryMessage,
                    }),
                    dispatch,
                ),
        )(withStyles(styles, { withTheme: true })(TicketFheDetails)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/TicketFhe/details.js